import './sky-blog-slider.scss';

document.addEventListener('DOMContentLoaded', function () {
    // Get all blog sliders
    const sliders = document.querySelectorAll('.blog-slider');
    if (!sliders.length) return;

    // Function to initialize sliders
    const initializeSliders = () => {
        sliders.forEach(slider => {
            // Skip already initialized sliders
            if (slider.classList.contains('initialized')) return;

            const swiperContainer = slider.querySelector('.swiper-container');
            if (!swiperContainer) return;

            // Get configuration from data attributes
            const speed = parseInt(slider.dataset.speed) || 5000;
            const pauseOnHover = slider.dataset.pauseOnHover === 'true';
            const showControls = slider.dataset.showControls === 'true';
            const autoScroll = slider.dataset.autoScroll === 'true';

            // Swiper configuration
            const swiperOptions = {
                slidesPerView: 3,
                spaceBetween: 30,
                loop: true,
                updateOnImagesReady: true,
                watchSlidesProgress: true,
                autoplay: autoScroll ? {
                    delay: speed,
                    disableOnInteraction: false
                } : false,
                pagination: {
                    el: `#${slider.id} .swiper-pagination`,
                    clickable: true,
                },
                breakpoints: {
                    1201: { slidesPerView: 3, spaceBetween: 30 },
                    1024: { slidesPerView: 2, spaceBetween: 30 },
                    768: { slidesPerView: 2, spaceBetween: 20 },
                    576: { slidesPerView: 1, spaceBetween: 10 },
                    0: { slidesPerView: 1, spaceBetween: 10 }
                },
                on: {
                    init: function () {
                        // Mark as initialized
                        slider.classList.add('initialized');
                    }
                }
            };

            // Initialize Swiper
            const swiper = new Swiper(swiperContainer, swiperOptions);

            // Add pause on hover functionality if enabled
            if (pauseOnHover && autoScroll) {
                swiperContainer.addEventListener('mouseenter', () => swiper.autoplay.stop());
                swiperContainer.addEventListener('mouseleave', () => swiper.autoplay.start());
            }
        });
    };

    // Initialize with a slight delay to ensure DOM is fully processed
    if (document.readyState === 'complete') {
        initializeSliders();
    } else {
        // Use requestAnimationFrame for smoother initialization
        requestAnimationFrame(initializeSliders);
    }
});